import React from "react";

const Privacy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 via-blue-50/30 to-white px-4 py-12 sm:px-6 sm:py-16">
      <article className="mx-auto max-w-4xl [overflow-wrap:anywhere] rounded-3xl border border-slate-200 bg-white p-6 text-slate-700 shadow-[0_18px_60px_rgba(15,23,42,0.07)] sm:p-10 [&_a]:break-words [&_a]:font-medium [&_a]:text-blue-700 [&_a]:underline-offset-4 [&_h2]:text-slate-950 [&_li]:leading-7 [&_p]:leading-7">
      <header className="mb-10 border-b border-slate-200 pb-7">
        <p className="mb-3 text-xs font-bold uppercase tracking-[0.2em] text-blue-700">Legal</p>
        <h1 className="text-3xl font-black tracking-tight text-slate-950 sm:text-4xl">Privacy Policy</h1>
      </header>

      <section className="mb-6">
        <h2 className="text-2xl font-bold mb-2">1. Introduction</h2>
        <p>
          JobZam® (UK Trademark No. <strong>UK00004249682</strong>) is owned and operated by
          Power Data Tech Ltd. Your privacy matters to us. This Privacy Policy explains how we
          collect, use, and protect your data when you use our platform.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-bold mb-2">2. Information We Collect</h2>
        <ul className="list-disc list-inside space-y-1">
          <li>Your name and email address when you sign up or log in (e.g. via Google or email).</li>
          <li>
            Your uploaded resumes and job descriptions are processed temporarily to provide ATS analysis
            and resume optimization. We do not permanently store uploaded resumes or job descriptions
            after processing.
          </li>
          <li>
            Usage data such as resume generation count, selected plans (free, 30-day, 3-month),
            and feature usage.
          </li>
          <li>Feedback or support messages you submit voluntarily.</li>
          <li>
            Payment-related information is handled securely by our payment providers, such as Stripe.
            We do not store your full card details on our servers.
          </li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-bold mb-2">3. How We Use Your Data</h2>
        <ul className="list-disc list-inside space-y-1">
          <li>To match and optimise your resume against job descriptions.</li>
          <li>To enforce free usage limits and manage 30-day / 3-month premium access.</li>
          <li>To maintain your account, login sessions, and security.</li>
          <li>To communicate important updates, support, and service-related messages.</li>
          <li>To analyse usage and improve our overall product experience.</li>
          <li>To comply with legal, tax, and accounting obligations where required.</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-bold mb-2">4. Data Sharing</h2>
        <p>
          We do not sell your personal data. We may share limited information with trusted
          third-party providers only as needed to operate JobZam®, such as:
        </p>
        <ul className="list-disc list-inside space-y-1 mt-2">
          <li>Authentication and database services, such as Supabase.</li>
          <li>Payment processing, such as Stripe.</li>
          <li>Analytics and error monitoring tools to improve stability and performance.</li>
          <li>Email or communication services for notifications and support.</li>
        </ul>
        <p className="mt-2">
          These providers are required to handle your data securely and only for the purposes
          described above.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-bold mb-2">5. Data Security</h2>
        <p>
          We use secure infrastructure, access controls, and encryption where appropriate to help
          protect your information. However, no method of transmission or storage over the internet
          is 100% secure, and we cannot guarantee absolute security.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-bold mb-2">6. Your Rights</h2>
        <p>
          You can request access, correction, or deletion of your personal data at any time by
          contacting us at{" "}
          <a href="mailto:team@jobzam.co" className="text-blue-600 underline">
            team@jobzam.co
          </a>
          . Depending on your location, you may also have additional rights under applicable data
          protection laws, such as UK GDPR.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-bold mb-2">7. Data Retention</h2>
        <p>
          We keep your account, usage, and payment-related data only for as long as necessary to
          provide our services, comply with legal obligations, resolve disputes, and enforce our
          agreements. Uploaded resumes and job descriptions are processed temporarily and are not
          permanently stored after processing.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-2xl font-bold mb-2">8. Cookies</h2>
        <p>
          We use cookies and similar technologies to manage login sessions and collect basic
          analytics. You can control or disable cookies through your browser settings, but some
          features of JobZam® may not function correctly without them.
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-bold mb-2">9. Updates to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Changes will be posted on this page
          with the latest revision date. Continued use of JobZam® after updates are published
          indicates acceptance of the revised policy.
        </p>
      </section>
      </article>
    </div>
  );
};

export default Privacy;
